module.exports = __webpack_public_path__ + "static/img/summer_yingtaoPic.adf873da.png";